import { PaziaButton } from "components/atoms";
import { ModalHeader } from "../../components/templates/Modals/ModalHeader";
import { BulkTrainerActionResultApi } from "api/trainers/trainerAccountApi";
import { getBulkTrainerActionLevel, getBulkTrainerActionSummaryLine } from "./bulkTrainerActionUtils";

interface BulkTrainerActionResultSummaryProps {
  result: BulkTrainerActionResultApi;
  successVerb: string;
  totalLabel: string;
  onClose: () => void;
}

const LEVEL_TEXT_CLASS: Record<string, string> = {
  success: "text-green-600 dark:text-green-400",
  warning: "text-amber-600 dark:text-amber-400",
  error: "text-red-600 dark:text-red-400",
};

export const BulkTrainerActionResultSummary = ({
  result,
  successVerb,
  totalLabel,
  onClose,
}: BulkTrainerActionResultSummaryProps) => {
  const level = getBulkTrainerActionLevel(result);

  return (
    <>
      <ModalHeader>Podsumowanie</ModalHeader>
      <p className={`text-sm font-medium ${LEVEL_TEXT_CLASS[level]}`}>
        {getBulkTrainerActionSummaryLine(result, successVerb, totalLabel)}
      </p>

      {result.skipped.length > 0 && (
        <div className="mt-4 max-h-96 overflow-y-auto rounded border border-slate-200 dark:border-slate-700">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 dark:bg-slate-800">
              <tr>
                <th className="px-3 py-2 text-left font-medium text-slate-600 dark:text-slate-300">Trener</th>
                <th className="px-3 py-2 text-left font-medium text-slate-600 dark:text-slate-300">Powód</th>
              </tr>
            </thead>
            <tbody>
              {result.skipped.map((s) => (
                <tr key={s.trainerId} className="border-t border-slate-200 dark:border-slate-700">
                  <td className="px-3 py-2 text-slate-800 dark:text-slate-100">{s.trainerName}</td>
                  <td className="px-3 py-2 text-slate-500 dark:text-slate-400">{s.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-6 flex justify-end">
        <PaziaButton type="primary" onClick={onClose}>
          Zamknij
        </PaziaButton>
      </div>
    </>
  );
};
